import React from 'react';
import PropTypes from 'prop-types';
import CwLabel from '../cwlabel/CwLabel';
import { getDate, getUtcDate, extractDate } from 'src/utils/DateUtils';
import css from './Days.scss';
import moment from 'moment';

/**
 * Each Day represents a cell in the calendar. Day objects are dynamically assigned their class based on whether they
 * are the current day or the a selected.
 */
const Days = (props) => {
  const dateOnly = props.value ? extractDate(props.value, props.isDateTime) : undefined;
  const selected = props.isDateTime ? props.value : moment(dateOnly);
  
  /**
   * On click we'll create a day object and pass that object back up the chain so that it can update the value in the
   * date picker.
   */
  const handleClick = () => {
    const date = props.isDateTime ? getDate(props.day, props.month, props.year) : getUtcDate(props.day, props.month, props.year);
    props.onChange(date);
  };

  /**
   * Dynamically assigns a class, should be called by the parent div of the day object. The default class is the days
   * class, the current day gets assigned the today class, and the selected day gets assigned the selected class.
   */
  const getClass = () => {
    const date = moment();
    if (props.day === selected.date() && props.month === selected.month()) {
      return css.selected;
    } else if (props.day === date.date() && props.month === date.month()) {
      return css.today;
    } else {
      return css.days;
    }
  };

  return (
    <div className={getClass()} onClick={handleClick}>
      <CwLabel>{props.day.toString()}</CwLabel>
    </div>
  );

};

Days.propTypes = {
  /**
   * A working instance of a Date Object. Note that this value is not the same as the "value" displayed in the
   * DatePicker's text field but instead should represent the date associated with the state in CwDatePicker.
   */
  value: PropTypes.oneOfType([
    PropTypes.instanceOf(moment),
    PropTypes.instanceOf(Date),
  ]),
  /**
   * The actual day to be displayed. Should be a single number as a string.
   */
  day: PropTypes.number,
  /**
   * The current working month, should be a number as a string
   */
  month: PropTypes.number,
  /**
   * The current working year, should be a number as a string
   */
  year: PropTypes.number,
  /**
   * A function that should update the value in the text field when one has been selected from the Calendar.
   */
  onChange: PropTypes.func
};

export default Days;


// WEBPACK FOOTER //
// ./src/components/cwdatepicker/Days.jsx